const SHIFTCOVER_STATUS_PENDING = "pending";
const SHIFTCOVER_STATUS_OPEN = "open";
const SHIFTCOVER_STATUS_REJECTED = "rejected";
const SHIFTCOVER_STATUS_VOLUNTEERED = "volunteered";
const SHIFTCOVER_STATUS_DECLINED = "declined";
const SHIFTCOVER_STATUS_APPROVED = "approved";

const shiftCoverRequestStatuses = [
  {
    value: SHIFTCOVER_STATUS_PENDING,
    icon: "clock",
    class: "badge bg-warning text-dark",
    assignedLabel: "Your cover request is waiting for an admin to allow it", // label for the user whos shift this is
  },
  {
    value: SHIFTCOVER_STATUS_OPEN,
    icon: "people-arrows",
    class: "badge bg-light text-dark",
    assignedLabel:
      "Shift cover request is open. You will still need to do this shift until cover is confirmed.",
  },
  {
    value: SHIFTCOVER_STATUS_REJECTED,
    icon: "ban",
    class: "badge bg-danger",
    assignedLabel:
      "Your request for cover has been cancelled. You should do this shift as planned.",
    volunteeredLabel: "Shift cover was cancelled",
    volunteeredClass: "badge bg-danger",
    volunteeredIcon: "times",
  },
  {
    value: SHIFTCOVER_STATUS_VOLUNTEERED,
    icon: ["far", "hand-paper"],
    class: "badge bg-light text-dark",
    assignedLabel:
      "Shift cover request is open. You will still need to do this shift until cover is confirmed.",
    volunteeredLabel:
      "You have volunteered to cover this shift (not yet confirmed)",
  },
  {
    value: SHIFTCOVER_STATUS_DECLINED,
    icon: ["far", "hand-paper"],
    class: "badge bg-danger",
    assignedLabel:
      "Shift cover request is open. You will still need to do this shift until cover is confirmed.",
    volunteeredLabel: "Your request to cover this shift was declined",
  },
  {
    value: SHIFTCOVER_STATUS_APPROVED,
    icon: "check",
    class: "badge bg-success",
    assignedTemplate:
      "You have been approved to cover ${prevDisplayName}'s shift",
    assignedPrevUnassignedTemplate:
      "You have been approved to take on this shift",
    template: "Your old shift is being covered by ${displayName}", // you were the current assigned to, but now you're the 'old' data.
    volunteeredLabel: "This shift was covered by someone else",
    volunteeredClass: "badge bg-danger",
    volunteeredIcon: "times",
  },
];

export {
  shiftCoverRequestStatuses,
  SHIFTCOVER_STATUS_PENDING,
  SHIFTCOVER_STATUS_OPEN,
  SHIFTCOVER_STATUS_REJECTED,
  SHIFTCOVER_STATUS_VOLUNTEERED,
  SHIFTCOVER_STATUS_DECLINED,
  SHIFTCOVER_STATUS_APPROVED,
};
